// Vuex
import store from '@/store.js';
// i18n
import i18n from '@/i18n';
// Self-made Snackbar
import snackbar from '@/plugins/snackbar';

import consts from "@/consts.js";
import Request from './request';

async function imports(file) {// 导入
    var data = new FormData();
    data.append("excel", file);
    return Request('post', "api/materials/import", data);
}

async function fetch(data) {
    return Request('get', "api/materials", data);
}

async function exports(data) {// 导出报表
    store.dispatch("fullscreenLoading");
    const response = await Request('get', "api/materials/export", data);
    if (response.data && response.data.status.isOK()) {
        snackbar.info(i18n.t("Export.recordedHint"));
    }
    store.dispatch("fullscreenLoadingStop");
    return response;
}

async function fetchOne(id) {// 获取单个
    return Request('get', "api/materials/" + id);
}
async function fetchSupplier(id,data) {// 获取单个
    if (!data) data = {};
    data.limit = consts.limitAll; //获取全部
    return Request('get', "api/materials?supplier_id=" + id,data);
}

async function fetchAll(data) {
    if (!data) data = {};
    data.limit = consts.limitAll; //获取全部
    return Request('get', "api/materials", data);
}

async function fetchAllNoPaging(data) {
    if (!data) data = {};
    // data.limit = consts.limitAll; //获取全部
    return Request('get', "api/materials", Object.assign({},data,{
        itemsPerPage: consts.limitAll,
        limit: consts.limitAll,
    }));
}

async function fetchAllForSelect(data) {
    if (!data) data = {};
    data.limit = consts.limitAll; //获取全部
    data.fieldFilter = ["id","material_code","material_name","Standard.name","category_code"]; // 仅筛选少许必要字段
    return Request('get', "api/materials", data, false, false, true);
}

async function save(id, data) {// 编辑或新建数据（有id为编辑，没有id为新建）
    if (data.standard && data.standard.standard_details) {
        data.standard.standard_details = data.standard.standard_details.map(
            (standard_detail) => {
                standard_detail.default_flg = standard_detail.default_flg ? 1 : 0;
                return standard_detail;
            }
        )
    }
    if (data.material_category)
        data.category_code = data.material_category.code;

    if (id)
        return Request('patch', "api/materials/edit?id=" + id, data);
    else
        return Request('post', "api/materials/add", data);
}

async function del(id) {// 删除数据
    return Request('delete', "api/materials/" + id);
}

async function getPinyin(string) {
    return Request('get', "api/materials/get-pinyin-initials/" + string);
}

async function fetchGroups() {
    return Request('get', "api/materials/get-material-group");
}

async function bindDefaultSupplier(data) {
    return Request('patch', "api/materials/bind-default-supplier" , data);
}

export default {
    imports,
    fetch, exports,
    fetchOne,
    fetchAll,
    fetchAllNoPaging,
    fetchAllForSelect,
    save,
    del,
    getPinyin,
    fetchGroups,
    bindDefaultSupplier,
    fetchSupplier
};